import * as constants from "../../constants/constants";
import { uniq, uniqWith, intersection } from "ramda";
import { findIdFor } from "../helpers";

const singleSelectionList = [constants.ACQ_YEAR_FIRST, constants.ACQ_YEAR_LAST];

function _getAttributes(response) {
  return response.fields.map((field, rank) => {
    const title = field.alias;
    const attributes = response.features.map((item, index) => {
      const value = item.attributes[field.name];
      const label = field.domain
        ? field.domain.codedValues.find((x) => x.code === value).name
        : value;
      const layerId = item.attributes[constants.DATASET_ID];

      return {
        id: index,
        label,
        value,
        layerId,
      };
    });
    const aggregated = attributes.reduce((array, item) => {
      const layerIds = uniq(
        attributes.filter((x) => x.value === item.value).map((x) => x.layerId)
      );
      const newItem = {
        id: item.id,
        title,
        label: item.label,
        value: item.value,
        layerIds,
        disabled: false,
        visible: false,
        selected: false,
        fieldName: field.name,
        fieldIndex: rank,
        footprintEnabled: false,
        footprintDisabled: false,
        naturalColored: false,
        hasNaturalColor: false,
        zoom: 0,
        zoomed: false,
        labeled: false,
        labelDisabled: false,
        constraint: 0,
      };
      array.push(newItem);
      return array;
    }, []);
    const reducedAggregated = uniqWith(
      (x, y) => x.value === y.value,
      aggregated
    );
    return {
      title,
      name: field.name,
      features: reducedAggregated,
      // selected: [],
      // frozen: false,
      singleSelection: singleSelectionList.includes(field.name),
    };
  });
}

const parseElevationFields = (response) => {
  const responseAttributes = _getAttributes(response);
  return responseAttributes.map((attribute) => {
    if (attribute.name === constants.DATASET_ID) {
      const features = attribute.features;
      return { ...attribute, features };
    }
    return attribute;
  });
};

const parseImageryFields = (response) => {
  const responseAttributes = response.fields.map((field, rank) => {
    const title = field.alias;
    const attributes = response.features.map((item, index) => {
      const value = item.attributes[field.name];
      const label = field.domain
        ? field.domain.codedValues.find((x) => x.code === value).name
        : value;
      const layerId = item.attributes[constants.DATASET_ID];
      return {
        id: index,
        label,
        value,
        layerId,
        constraint: item.attributes[constants.CONSTRAINTS],
      };
    });
    const aggregated = attributes.reduce((array, item) => {
      const layerIds = uniq(
        attributes.filter((x) => x.value === item.value).map((x) => x.layerId)
      );
      const newItem = {
        id: item.id,
        title,
        label: item.label,
        value: item.value,
        layerIds,
        disabled: false,
        visible: false,
        selected: false,
        fieldName: field.name,
        fieldIndex: rank,
        footprintEnabled: false,
        footprintDisabled: true,
        naturalColored: false,
        hasNaturalColor: false,
        zoom: 0,
        zoomed: false,
        constraint: item.constraint ? item.constraint : 0,
      };
      array.push(newItem);
      return array;
    }, []);
    const reducedAggregated = uniqWith(
      (x, y) => x.value === y.value,
      aggregated
    );
    return {
      id: field.name,
      title,
      index: rank,
      name: field.name,
      features: reducedAggregated,
      // singleSelection: singleSelectionList.includes(field.name)
    };
  });

  const productDefinitions = responseAttributes.find(
    (attribute) => attribute.name === constants.PRO_DEF
  );

  let colorIds = [];
  if (productDefinitions)
    colorIds = productDefinitions.features.find(
      (item) => item.label === "Natural Color + Infrared"
    ).layerIds;

  return responseAttributes.map((attribute) => {
    if (attribute.name === constants.DATASET_ID) {
      const features = attribute.features.map((feature) => {
        feature.hasNaturalColor = !!intersection(feature.layerIds, colorIds)
          .length;
        return feature;
      });
      return { ...attribute, features };
    }
    return attribute;
  });
};

export const sortAttributesLayers = ({ attributes, webmap, imagery }) => {
  if (!webmap || !imagery) return attributes;
  const sortedLayers = webmap.layers
    .filter((layer) => layer.title !== imagery.title)
    .map((layer, index) => ({
      index,
      title: layer.title,
      layerId: findIdFor(layer),
    }));
  return attributes.map((attribute) => {
    if (attribute.name === constants.DATASET_ID) {
      const features = attribute.features.map((feature) => {
        const id = sortedLayers.find((l) => l.layerId === feature.layerIds[0])
          .index;
        return { ...feature, id };
      });
      return { ...attribute, features };
    }
    return attribute;
  });
};

export const parseFields = (response, configName) => {
  if (configName === "elevation") return parseElevationFields(response);
  else if (configName === "imagery") return parseImageryFields(response);
  else {
    const items = parseImageryFields(response);
    return items;
  }
};
